<template>
  <base-layout>
    <router-view></router-view>
  </base-layout>
</template>

<script>
const BaseLayout = () => import("@/components/BaseUserAccount.vue");
export default {
  name: "mock-test",
  data: () => ({}),
  components: {
    BaseLayout,
  },
};
</script>

